import React, { Component } from 'react';

// FontAwesome needs a family class (fas/far/fal/fad/fab) alongside the fa-* glyph.
// Tabs pass icons like "fa-eye" without one, so default to solid when it's missing.
const normalizeIcon = (icon) => {
    if (!icon) return 'fas fa-circle';
    return /\b(fas|far|fal|fad|fab|fa-solid|fa-regular|fa-light|fa-duotone|fa-brands)\b/.test(icon)
        ? icon
        : `fas ${icon}`;
};

// Shared layout for a tab's content: header (icon + title + description,
// optional right-aligned controls) and a body region.
class TabSection extends Component {
    render() {
        // Accept both `desc` (student-app tabs) and `description` (college tabs).
        const { icon, title, desc, description, headerRight, children } = this.props;
        const subtitle = desc != null ? desc : description;
        return (
            <div className="sp-content-card">
                <div className="sp-section-head">
                    <div className="sp-section-title-wrap">
                        <div className="sp-section-icon">
                            <i className={normalizeIcon(icon)} />
                        </div>
                        <div>
                            <h5 className="sp-section-title">{title}</h5>
                            {subtitle ? <p className="sp-section-desc">{subtitle}</p> : null}
                        </div>
                    </div>
                    {headerRight}
                </div>
                <div className="sp-section-body">{children}</div>
            </div>
        );
    }
}

// Simple "data coming soon" body that references the current student.
export class SectionPlaceholder extends Component {
    render() {
        const { icon, label, student } = this.props;
        const who = student && student.name ? student.name : 'this student';
        return (
            <div className="sp-placeholder">
                <i className={normalizeIcon(icon)} />
                <p>{label} details for {who} will appear here.</p>
            </div>
        );
    }
}

export default TabSection;
